import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const UTM_PARAMS_KEY = 'vhs_utm_params';

export const useUtmTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fclid'];
    
    let foundUtm = {};
    let hasNewUtm = false;

    utmKeys.forEach(key => {
      if (params.has(key)) {
        foundUtm[key] = params.get(key);
        hasNewUtm = true;
      }
    });

    // If the current URL has any UTM parameters, it's a new landing.
    // We save these new parameters, overwriting any old ones.
    if (hasNewUtm) {
      console.log('New UTM parameters detected. Saving to localStorage:', foundUtm);
      localStorage.setItem(UTM_PARAMS_KEY, JSON.stringify(foundUtm));
    }

  }, [location]); // This effect runs every time the URL changes.
};

// Helper function to be used in other components
export const getStoredUtmParams = () => {
  const storedData = localStorage.getItem(UTM_PARAMS_KEY);
  if (storedData) {
    try {
      return JSON.parse(storedData);
    } catch (e) {
      console.error('Failed to parse stored UTM params:', e);
      return {};
    }
  }
  return {};
};